<div class="grid">

    <div class="col-11">
        <p-card header="Message Executions Log" subheader="" styleClass="ui-card-light" >

            <!--  C R I T E R I A  -->
            <div class="grid">

                <div class="grid col-5">

                    <div class="col-4">
                        <label for="dateFrom" class="margin-right">Date From:</label>
                        <p-datePicker id="dateFrom" [(ngModel)]="selectedDateFrom" dateFormat="yy-mm-dd" 
                        [showIcon]="true" class="margin-left"></p-datePicker>
                    </div>
    
                    <div class="col-4">
                        <label for="dateTo" class="margin-left">Date To:</label>
                        <p-datePicker id="dateTo" [(ngModel)]="selectedDateTo" dateFormat="yy-mm-dd" 
                           [showIcon]="true" class="margin-left"></p-datePicker>
                    </div>

                    @if(isBrandSelectionShown) {
                        <div class="col-4">
                            <label for="brandCode">Brand Code:</label>
                            <p-select id ="brandCode" [options]="brandCodes" [(ngModel)]="selectedBrandCode" 
                                (onChange)="onChangeBrand($event)"
                                [editable]="false" class="margin-left" [style]="{'width':'100%'}">
                            </p-select>
                        </div>
                    }
    
                </div>

                <div class="grid col-4">

                    @if(isBatchTypeSelectionShown) {
                        <div class="col-4">
                            <label for="batchType">Batch Type:</label>
                            <p-select id ="batchType" [options]="batchTypes" [(ngModel)]="selectedBatchType"
                                class="margin-left" [style]="{'width':'100%'}" [editable]="false">
                            </p-select>
                        </div>
                    }
    
                    <div class="col-4">
                        <label for="executionMethod">Execution Method:</label>
                        <p-select id ="executionMethod" [options]="executionMethods" [(ngModel)]="selectedExecutionMethod"
                            class="margin-left" [style]="{'width':'100%'}" [editable]="false">
                        </p-select>
                    </div>
    
                    <div class="col-4">
                        <label for="statusCode">Status:</label>
                        <p-select id ="statusCode" [options]="statusCodes" [(ngModel)]="selectedStatusCode" 
                            class="margin-left" [style]="{'width':'100%'}" [editable]="false">
                        </p-select>
                    </div>
    
                </div>

                <div class="grid col-3">

                    <div class="col-2"></div>

                    <div class="col-8">
                        <p-button label="Search" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="onSearchClick($event)"></p-button>
                        <!-- <p-button label="Next" styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" (click)="isNextButtonShown($event)"></p-button> -->
                        <p-button label="Clear" styleClass="p-button-danger wal-danger p-button-raised p-button-rounded margin-left" (click)="onClearClick($event)"></p-button>
                    </div>
    
                    <div class="col-2" id="idSpinner" [hidden]="isSpinnerHidden">
                    <div class="loader"></div>  
                    </div>
    
                </div>


            </div>  

            <!--  G R I D  -->
            
            <div class="grid">

                <p-table #dtMessageBatchExecs [columns]="messageBatchExecsCols" [value]="messageBatchExecs" selectionMode="single" 
                    [(selection)]="selectedMeaagesgBatchExec" class="wal-table p-datatable-striped p-datatable-sm"
                     [rowsPerPageOptions]="[10,15,25,50]" [showCurrentPageReport]="true"
                    sortMode="multiple" (onRowSelect)="onMessageBatchExecRowSelect($event)" [paginator]="false" [rows]="25">
                    <ng-template pTemplate="caption">
                    Log of Message Batch Executions
                    </ng-template>
                    <ng-template pTemplate="caption">
                    <div style="text-align: right">        
                        <i class="pi pi-search" style="margin:4px 4px 0 0"></i>
                        <input type="text" pInputText size="50" placeholder="Global Filter" (input)="dtMessageBatchExecs.filterGlobal($any($event.target).value, 'contains')" style="width:auto">
                    </div>
                </ng-template>
                    <ng-template pTemplate="header" let-columns>
                    <tr>
						@for (col of columns; track col.field) {
							<th [pSortableColumn]="col.field"
								[style.display]="col.display"
								[style.width]="col.width">
								{{ col.header }}
								<!-- <p-sortIcon [field]="col.field"></p-sortIcon> -->
							</th>
						}                     
                    </tr>
                </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr [pSelectableRow]="rowData">
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ rowData[col.field] }}
                            </td>
                        }
                    </tr>
                </ng-template>

                <ng-template pTemplate="summary">
                    <div style="text-align:left">
                        <div class="ui-helper-clearfix">
                            <p-button label="Prior" *ngIf="isPriorButtonShown" styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" (click)="onPriorClick($event)"></p-button>
                            <p-button label="Next"  *ngIf="isNextButtonShown" styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" (click)="onNextClick($event)"></p-button>
                            <!-- <p-button styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left"
                                label="Export" (click)="onFileCreationRequest($event)" style="float:right">
                            </p-button> -->
                        </div>
                    </div>
                </ng-template>    


                </p-table> 

            </div>

            <p-footer>
                <mat-icon class="nav-caption wal-center">account_balance</mat-icon>
            </p-footer>
        </p-card>
    </div>            

</div>    

<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="message-exec-viewer"></p-confirmDialog>
